export enum MeetingStatus {
  Processed = 'Processed',

  UnProcessed = 'UnProcessed',

  PartialProcessed = 'PartialProcessed',
}
